import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class ModuleDiscussion extends Icon {
  static defaultProps = {
    color: '#FFFFFF',
    size: 16,
    viewPortSize: 18
  };

  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path
            d="M15.1,8.2c0-1.8-1.2-3.6-3.9-4c0.1,0.2,0.2,0.4,0.3,0.7c1.9,0.4,3,1.6,3,3.3c0,0.8-0.3,1.6-0.8,2.2l0,0.3
          l0.4,0.8l-0.9-0.5l-0.3,0c-0.7,0.4-1.6,0.6-2.7,0.6c-1.1,0-2-0.2-2.7-0.7c-0.3,0-0.6,0.1-0.9,0.1c0.8,0.7,2,1.2,3.7,1.2
          c1.1,0,2.1-0.2,2.9-0.6l1.6,0.8l0.4-0.4l-0.8-1.5C14.8,10,15.1,9.2,15.1,8.2z"
          />
          <path
            d="M1.7,10.7l-0.4-0.4L2,8.9C1.5,8.2,1.2,7.4,1.2,6.5c0-2,1.5-4.1,5-4.1s5,2.1,5,4.1s-1.5,4.1-5,4.1
          c-1.1,0-2.1-0.2-2.9-0.6L1.7,10.7z M3.2,9.3l0.3,0c0.7,0.4,1.6,0.6,2.7,0.6c2.6,0,4.4-1.4,4.4-3.5S8.8,3,6.2,3S1.8,4.4,1.8,6.5
          c0,0.8,0.3,1.6,0.8,2.2l0,0.3L2.2,9.8L3.2,9.3z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/ModuleDiscussion.js